var _defs, _g, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSunrain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_6",
    "data-name": "Layer 6",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #66afeb;\n      }\n\n      .cls-2 {\n        fill: #ffbb19;\n      }\n\n      .cls-3 {\n        fill: #9ec5fb;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 18.04,
    cy: 11.36,
    r: 4.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.04,6.17c.36,0,.65-.29,.65-.65V3.36c0-.36-.29-.65-.65-.65s-.65,.29-.65,.65v2.17c0,.36,.29,.65,.65,.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.45,7.69c.25,.25,.66,.25,.92,0,.25-.25,.25-.66,0-.92l-1.53-1.53c-.25-.25-.66-.25-.92,0-.25,.25-.25,.66,0,.92l1.53,1.53Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 9.38,
    y: 10.71,
    width: 3.47,
    height: 1.3,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.45,15.03l-1.53,1.53c-.25,.25-.25,.66,0,.92h0c.25,.25,.66,.25,.92,0l1.53-1.53c.25-.25,.25-.66,0-.92-.25-.25-.66-.25-.92,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.04,16.55c-.36,0-.65,.29-.65,.65v2.17c0,.36,.29,.65,.65,.65s.65-.29,.65-.65v-2.17c0-.36-.29-.65-.65-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.62,15.03c-.25-.25-.66-.25-.92,0-.25,.25-.25,.66,0,.92l1.53,1.53c.25,.25,.66,.25,.92,0h0c.25-.25,.25-.66,0-.92l-1.53-1.53Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 23.22,
    y: 10.71,
    width: 3.47,
    height: 1.3,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.62,7.69l1.53-1.53c.25-.25,.25-.66,0-.92-.25-.25-.66-.25-.92,0l-1.53,1.53c-.25,.25-.25,.66,0,.92,.25,.25,.66,.25,.92,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M22.52,15.96c-.29,0-.56,.05-.82,.13,0-.04,0-.08,0-.13,0-3.34-2.71-6.05-6.05-6.05-2.82,0-5.18,1.93-5.85,4.55-.22-.04-.45-.07-.69-.07-2.1,0-3.81,1.71-3.81,3.81,0,1.89,1.39,3.57,3.2,3.87h.03s7.15,0,7.15,0c0,0,0,0,0,0s0,0,0,0h6.49c.15,0,.26,0,.35,0,1.68,0,3.02-1.39,3.02-3.07s-1.36-3.04-3.04-3.04Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.29,27.97h0c-.52-.19-.78-.77-.59-1.29l1.37-3.03c.19-.52,.77-.78,1.29-.59h0c.52,.19,.78,.77,.59,1.29l-1.37,3.03c-.19,.52-.77,.78-1.29,.59Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.69,29.26h0c-.52-.19-.78-.77-.59-1.29l1.37-3.03c.19-.52,.77-.78,1.29-.59h0c.52,.19,.78,.77,.59,1.29l-1.37,3.03c-.19,.52-.77,.78-1.29,.59Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunrain);
export default __webpack_public_path__ + "static/media/sunrain.a59b5a546620fe98025e1698cb4e35c5.svg";
export { ForwardRef as ReactComponent };